module.exports = __webpack_public_path__ + "static/heckmondwike-grammar-school-bus-sm-6cf29166fdcb057c7238bbefab578ff9.jpg";